<template>
  <div class="table-area">
    <div class="title-2" style="margin-bottom: 15px">采集异常学生筛查</div>
    <a-tabs :active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <TableList
          :columns="columns"
          :tableData="dataSource"
          :scroll="{}"
          bordered
          :loading="loading"
          :pagination="ipagination"
          @change="handleTableChange"
          style="min-height: 350px"
        >
          <div slot="queryArea" class="query-area">
            <div>
              <j-dict-select-tag
                style="width: 170px; margin-right: 15px"
                placeholder="请选择年级"
                v-model="queryParam.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                :isShowEmpty="false"
                @select="$set(queryParam, 'classId', undefined)"
                @clear="$set(queryParam, 'classId', undefined)"
              />
              <j-dict-select-tag
                style="width: 170px; margin-right: 15px"
                placeholder="请选择班级"
                v-model="queryParam.classId"
                :dictCode="
                  'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                "
                :async="true"
                :disabled="!queryParam.gradeId"
                :isShowEmpty="false"
              />
              <!-- <j-dict-select-tag
                v-model="noCollectReasonKey"
                placeholder="请选择反馈原因"
                style="width: 170px; margin-right: 15px"
                dictCode="student_without_face_reason"
                :isShowEmpty="false"
              /> -->
              <a-input-search
                v-model="queryParam.studentName"
                placeholder="请输入学生名字"
                class="search-space"
                style="width: 170px"
                @change="searchName"
              />
              <a-range-picker
                v-if="tabKey != 2"
                v-model="dateRange"
                :getCalendarContainer="(node) => node.parentNode"
                style="width: 220px; margin-right: 15px"
                @change="changeDateRange"
              />
              <a-button type="primary" @click="queryTable">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 15px">
                重置
              </a-button>
            </div>
            <div>
              <a-popconfirm
                title="确定要一键提醒吗？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="oneKeyReminder"
              >
                <a-button
                  icon="alert"
                  :loading="btnLoading"
                  type="primary"
                  style="margin-right: 15px"
                >
                  一键提醒
                </a-button>
              </a-popconfirm>
              <a-button
                icon="download"
                :loading="exportXlsLoading"
                @click="handleExportXls(item.tab)"
              >
                导出
              </a-button>
            </div>
          </div>
          <div class="flex-align-center" slot="labelsList" slot-scope="{ record }">
            <span
              v-for="(item, index) in record.labelsList"
              :key="index"
              :style="{
                color: getStuTagColorConfig(item.key).color,
                background: getStuTagColorConfig(item.key).bgColor,
              }"
              class="label-item"
            >
              {{ item.text }}
            </span>
          </div>
          <!-- 反馈原因 -->
          <template slot="noCollectReason" slot-scope="{ record }">
            <a-tooltip v-if="record.noCollectReason && record.noCollectReason.length >= 15">
              <template slot="title">{{ record.noCollectReason }}</template>
              {{ record.noCollectReason.substring(0, 15) + '...' }}
            </a-tooltip>
            <span v-else>{{ record.noCollectReason }}</span>
          </template>
          <!-- 操作 -->
          <template slot="operation" slot-scope="{ record }">
            <div style="color: #1890ff; cursor: pointer" @click="viewDetail(record)">查看详情</div>
          </template>
        </TableList>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { postAction } from '@api/manage'
import { getDictCodeData, simpleDebounce, getStuTagColorConfig } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { formatYearMonthDate } from '@/utils/date'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    align: 'center',
  },
  {
    title: '姓名',
    dataIndex: 'studentName',
    align: 'center',
  },
  {
    title: '班级',
    dataIndex: 'className',
    align: 'center',
  },
  {
    title: '班主任',
    dataIndex: 'teacherName',
    align: 'center',
  },
  // {
  //   title: '未采集时间',
  //   dataIndex: 'notCollectTime',
  //   align: 'center',
  // },
  // {
  //   title: '反馈原因',
  //   dataIndex: 'noCollectReason',
  //   align: 'center',
  //   scopedSlots: { customRender: 'noCollectReason' },
  // },
  // {
  //   title: '反馈时间',
  //   dataIndex: 'commitReasonTime',
  //   align: 'center',
  // },
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   align: 'center',
  //   scopedSlots: { customRender: 'operation' },
  // },
]

export default {
  name: 'AbnormalStudentScreening',
  components: {
    TableList,
  },
  mixins: [JeecgListMixin],
  props: {
    tabPaneConfig: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabKey: 1,
      noCollectReasonKey: undefined,
      dateRange: [],
      columns: [],
      url: {
        list: '/statisticV2/getStudentBaseMap',
        exportXlsUrl: '/statisticV2/exportStudentBaseMapXls',
      },
      disableMixinCreated: true,
      btnLoading: false,
    }
  },
  created() {
    this.queryParam.type = this.tabKey
    const query = this.$route.query
    if (this.tabKey != 2 && query?.dateRange) {
      this.dateRange = query.dateRange
      this.queryParam.beginDate = this.dateRange[0]
      this.queryParam.endDate = this.dateRange[1]
    }
    this.loadData(1)
  },
  watch: {
    tabKey: {
      handler(val) {
        if (val == 2) {
          this.columns = columns.filter((item) => item.dataIndex != 'notCollectTime')
          return
        }
        this.columns = columns
      },
      immediate: true,
    },
  },
  methods: {
    getStuTagColorConfig,
    queryTable() {
      // if (this.noCollectReasonKey) {
      //   this.queryParam.noCollectReason = getDictCodeData(
      //     'student_without_face_reason',
      //     this.noCollectReasonKey,
      //     true
      //   )
      // } else {
      //   this.queryParam.noCollectReason = undefined
      // }
      this.searchQuery()
    },
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam.type = key
      if (this.tabKey != 2) {
        this.queryParam.beginDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      } else {
        this.queryParam.beginDate = undefined
        this.queryParam.endDate = undefined
      }
      this.loadData(1)
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value?.trim()
      this.loadData(1)
    }, 800),
    async oneKeyReminder() {
      this.btnLoading = true
      const res = await postAction('/statisticV2/haveBaseMapPush', {
        ...this.queryParam,
        type: this.tabKey,
      })
      const { success } = res
      this.btnLoading = false
      if (success) {
        this.$message.success('一键提醒成功')
        return
      }
      this.$message.error('一键提醒失败')
    },
    changeDateRange(dateArr) {
      if (dateArr.length) {
        this.dateRange = [formatYearMonthDate(dateArr[0]), formatYearMonthDate(dateArr[1])]
      } else {
        this.dateRange = []
      }
      this.queryParam.beginDate = this.dateRange?.[0]
      this.queryParam.endDate = this.dateRange?.[1]
    },
    searchReset() {
      this.queryParam = {}
      this.dateRange = []
      this.queryParam.type = this.tabKey
      this.loadData(1)
    },
    viewDetail(record) {
      this.$emit('viewDetail', record, this.tabKey)
    },
  },
}
</script>

<style scoped lang="less">
.table-area {
  padding: 20px;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e8e8e8;

  .query-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .search-space {
      width: 140px;
      margin-right: 15px;
    }
  }

  .label-item {
    margin: 0 4px;
    padding: 2px 8px;
    color: #575757;
    background-color: #fafafa;
    border-radius: 12px;
  }
}

.title-2 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
</style>
